import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferConfigurePageContainer } from '@occc-app/offerHelpers/components/OfferConfigurePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { BillboardConfigureFormContainer } from '@occc-app/routes/Billboard/components/BillboardConfigureForm/BillboardConfigureFormContainer';
import { useChainId } from '@occc-app/Chain/hooks';

import { messages } from '../messages';
import { getCreatePageLinks, useGetCampaignName } from '../../CampaignComponents/utils';

export const BillboardConfigurePageContainer: React.FC = () => {
  const { id: campaignId = '', billboardId = '' } = useParams<{
    id: string;
    billboardId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);

  return (
    <OfferConfigurePageContainer
      campaignId={campaignId}
      offerId={billboardId}
      getBreadcrumbLinks={(offerName) => getCreatePageLinks(campaignId, campaignName, offerName)}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Billboard}
      showExternalUrl
      ignoreConfigureFormSubmit
      ConfigureFormContainer={BillboardConfigureFormContainer}
    />
  );
};
